import ArrowDropDown from '@material-ui/icons/ArrowDropDown'
import Menu from '@material-ui/core/Menu'
import React from 'react'
import { svgIconStyle } from '../../../theme/Global'
import { CustomLink } from './styles'
import MenuItemRenderer from './menuItem'

const MenuRenderer = ({ activateItem, anchorEl, handleClick, handleClose, items, text, displayArrow }) => (
  <React.Fragment>
    <CustomLink aria-haspopup="true" onClick={handleClick}>
      <div style={{
        display: 'inline-block',
        position: 'relative',
        top: '0px'
      }}
      >
        {text}
      </div>
      {displayArrow && (
        <ArrowDropDown
          style={svgIconStyle({
            display: 'inline-block',
            position: 'relative',
            top: '7px'
          })}
        />
      )}
    </CustomLink>
    <Menu
      anchorEl={anchorEl}
      open={!!anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      getContentAnchorEl={null}
    >
      {items.map((item, index) => MenuItemRenderer({
        activateItem,
        item,
        index,
        handleClose
      }))}
    </Menu>
  </React.Fragment>
)

export default MenuRenderer
